/** Shared client-side auth / contact form validation. */

const EMAIL_RE = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

export function normalizeEmail(value) {
  return String(value || "").trim().toLowerCase();
}

export function isValidEmail(value) {
  const email = normalizeEmail(value);
  if (!email || email.length > 254) return false;
  if (email.includes("..")) return false;
  if (!EMAIL_RE.test(email)) return false;
  const [local, domain] = email.split("@");
  if (!local || !domain || local.length > 64) return false;
  if (!domain.includes(".")) return false;
  // Reject obviously fake / disposable-looking single-label hosts
  const tld = domain.split(".").pop();
  if (!tld || tld.length < 2) return false;
  return true;
}

export function isValidPersonName(value) {
  const name = String(value || "").trim();
  if (name.length < 2 || name.length > 80) return false;
  // Letters (incl. accents), spaces, apostrophes, hyphens — block URLs / injection noise
  if (!/^[\p{L}\p{M}][\p{L}\p{M}'’.\- ]{0,78}$/u.test(name)) return false;
  if (/https?:\/\//i.test(name) || /[<>{}[\]\\]/.test(name)) return false;
  return true;
}

export function isValidPassword(value) {
  const password = String(value || "");
  return password.length >= 8 && password.length <= 128;
}

/**
 * Validate auth form fields for a given mode.
 * Returns { ok: true } or { ok: false, message, field }.
 */
export function validateAuthForm(
  mode,
  { name = "", email = "", password = "", confirmPassword = "", code = "" } = {},
  { mfa = false } = {},
) {
  if (mfa) {
    const trimmed = String(code || "").trim();
    if (!/^[0-9A-Za-z-]{6,12}$/.test(trimmed)) {
      return { ok: false, field: "code", message: "Enter a valid authenticator or backup code." };
    }
    return { ok: true };
  }

  if (mode === "signup") {
    if (!isValidPersonName(name)) {
      return { ok: false, field: "name", message: "Enter your full name (letters only, at least 2 characters)." };
    }
  }

  if (mode === "signup" || mode === "login" || mode === "forgot") {
    if (!isValidEmail(email)) {
      return { ok: false, field: "email", message: "Enter a valid email address (for example name@business.com)." };
    }
  }

  if (mode === "signup" || mode === "login" || mode === "reset") {
    if (!isValidPassword(password)) {
      return { ok: false, field: "password", message: "Password must be at least 8 characters." };
    }
  }

  if (mode === "signup" || mode === "reset") {
    if (password !== confirmPassword) {
      return { ok: false, field: "confirmPassword", message: "Passwords do not match." };
    }
  }

  return { ok: true };
}
